<template>
  <div class="page-contact">
    <div class="content-box">
      <div class="left">
        <div class="title" id="leftTitle1">Contact Us<span>.</span></div>
        <div class="title" id="leftTitle2" style="margin-bottom: 0"></div>
      </div>
      <div class="right">
        <div class="item">
          <div class="title-box">
            <img src="@/assets/team/icon.png" alt="" />
            <div class="title">河北总部</div>
          </div>
          <div class="text">衡水市桃城区城市杰座A 座 11 层</div>
        </div>

        <div class="item">
          <div class="title-box">
            <img src="@/assets/team/icon.png" alt="" />
            <div class="title">北京分公司</div>
          </div>
          <div class="text">北京市房山区长阳镇溪雅苑一区12号1层</div>
        </div>
      </div>
    </div>
    <div class="footer-box">
      <div class="top">
        <div class="title1">聊一聊？相信我们都会感到相识恨晚</div>
        <div class="title2">
          您在哪里我们的服务就在哪里，全国范围内支持上门洽谈。
        </div>
      </div>
      <div class="center">
        <div class="title">合作咨询</div>
        <div class="content">
          <div class="tel-item">闫丽琴 18231817521</div>
          <div class="tel-item">冷建斐 18330855518</div>
          <div class="email-item">shanmuzhi@shanmuzhi .com</div>
        </div>
      </div>
      <div class="bottom">
        <div class="input-item">
          <div class="label">怎么称呼您？</div>
          <el-input v-model="name" placeholder="姓名"></el-input>
        </div>

        <div class="input-item">
          <div class="label">如何联系您？</div>
          <el-input v-model="phone" placeholder="电话"></el-input>
        </div>

        <div class="input-item need-item">
          <div class="label">您的项目需求有哪些？</div>
          <el-input
            v-model="content"
            placeholder="请填写您的项目需求"
          ></el-input>
        </div>

        <div class="sub-btn" @click="submit">提交</div>
      </div>
    </div>
    <div class="record-box">
      <div class="left">CopyRight @ 2017-2025 shanmuzhi.com Design</div>
      <div class="right" style="cursor: pointer" @click="toICP">
        All Rights Reserved 备案号：{{ ICPtext() }}
      </div>
    </div>
  </div>
</template>

<script>
import utils from '@/api/Utils';
import { pageApi } from '@/api';
export default {
  name: 'home',
  data() {
    return {
      name: '',
      phone: '',
      content: '',
    };
  },
  components: {
    // PageSearch
  },
  mounted() {
    this.$nextTick(() => {
      new this.Typed('#leftTitle1', {
        strings: ['Contact Us<span>.</span>'],
        typeSpeed: 100,
      });

      new this.Typed('#leftTitle2', {
        strings: ['素未谋面，却能心照不宣'],
        typeSpeed: 100,
      });
    });
  },
  created() {
    // console.log(this.$publicData)
  },
  methods: {
    async submit() {
      if (!this.name || !this.phone || !this.content) {
        this.$message.error('请填写完整信息');
        return;
      }
      if (!/^\d{11}$/.test(this.phone)) {
        this.$message.error('请填写正确的手机号码');
        return;
      }
      const res = await pageApi.submitMessage({
        name: this.name,
        phone: this.phone,
        content: this.content,
      });
      if (res.code === 200) {
        this.$message.success('提交成功');
        this.name = '';
        this.phone = '';
        this.content = '';
      } else {
        this.$message.error('提交失败');
      }
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import url('./index.scss');
</style>
